// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../Typography", "../Icon", "./TagImage"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../Typography"), require("../Icon"), require("./TagImage"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Typography, global.Icon, global.TagImage);
    global.Tag = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Typography, _Icon, _TagImage) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Tag = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var ColorVariantToBgColors = {
    "default": 'cop-bg-gray-200',
    info: 'cop-bg-info',
    success: 'cop-bg-success',
    warning: 'cop-bg-warning',
    danger: 'cop-bg-danger'
  };
  var ColorVariantToBorderColors = {
    "default": 'cop-border-gray-300',
    info: 'cop-border-blue-300',
    success: 'cop-border-green-300',
    warning: 'cop-border-yellow-300',
    danger: 'cop-border-red-300'
  };
  var ColorVariantToTextColors = {
    "default": 'cop-primary',
    info: 'cop-text-info',
    success: 'cop-text-success',
    warning: 'cop-text-warning',
    danger: 'cop-text-danger'
  };
  var RemoveTag = function RemoveTag(_ref) {
    var onRemove = _ref.onRemove,
      onFocus = _ref.onFocus;
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: "cop-rounded-full cop-border-none cop-bg-transparent cop-p-[2px] cop-text-current cop-shadow-none hover:cop-cursor-pointer hover:cop-bg-white",
      onClick: onRemove,
      onFocus: onFocus
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: "Cross",
      className: "cop-h-2 cop-w-2 cop-text-xs"
    }));
  };
  var Tag = _exports.Tag = function Tag(_ref2) {
    var text = _ref2.text,
      color = _ref2.color,
      onRemove = _ref2.onRemove,
      onFocus = _ref2.onFocus,
      prefix = _ref2.prefix,
      className = _ref2.className;
    var bgColorClass = ColorVariantToBgColors[color !== null && color !== void 0 ? color : 'default'];
    var borderColorClass = ColorVariantToBorderColors[color !== null && color !== void 0 ? color : 'default'];
    var textColorClass = ColorVariantToTextColors[color !== null && color !== void 0 ? color : 'default'];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: ['cop-flex cop-h-[25px] cop-w-fit cop-items-center cop-justify-between cop-gap-[2px] cop-rounded-[35px] cop-border cop-border-solid cop-px-[10px]', bgColorClass, borderColorClass, textColorClass, className !== null && className !== void 0 ? className : ''].join(' ')
    }, prefix && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, prefix === 'Plus' || prefix === 'ChevronDown' ? /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: prefix,
      className: "cop-h-2 cop-w-2"
    }) : /*#__PURE__*/_react["default"].createElement(_TagImage.TagImage, {
      src: prefix,
      className: "cop-h-4 cop-w-4"
    })), /*#__PURE__*/_react["default"].createElement(_Typography.Heading, {
      variant: "sm",
      tag: "p",
      className: "cop-whitespace-nowrap"
    }, text), onRemove && /*#__PURE__*/_react["default"].createElement(RemoveTag, {
      onRemove: onRemove,
      onFocus: onFocus
    }));
  };
});
